<template>
    <div class="well-preview-image">
        <img class="rounded well-preview" :src="well.lastImageUrl" alt="" />

        <well-status-overlay :well="well" />

        <well-info v-if="!hideWellInfo" :well="well" />
    </div>
</template>

<script>
import WellStatusOverlay from './common/WellStatusOverlay'
import WellInfo from './WellInfo'
import { mapState } from 'vuex'
import { TREATMENT_PAGE_VIEWS } from '../../business/const'

export default {
    name: 'WellPreviewImage',
    components: { WellInfo, WellStatusOverlay },
    props: {
        well: {
            type: Object,
            required: true
        },
        hideWellInfo: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
.well-preview-image {
    position: relative;
}
</style>
